<template>
  <el-upload
    :accept="accept"
    :name="name"
    :action="action"
    :on-success="onSuccess"
    :on-error="onError"
    :show-file-list="false"
    :disabled="disabled || crop || (!!canDelete && !!file)"
  >
    <div class="app-upload" :class="[size]" :style="{ height: `${height}px` }">
      <div class="img" @click="handleImgClick" v-if="file" :style="{ backgroundImage: `url(${file})` }"></div>
      <div class="upload-icon bg-full" v-else :style="{ top: height ? `${46 - height / 2}px` : '' }"></div>
      <div class="bottom" v-if="!disabled">{{ file ? afterText : beforeText }}</div>
      <div v-if="canDelete && file" class="close-wrapper" @click.stop="$emit('delete')">
        <div class="close-icon bg-full"></div>
      </div>
      <label class="label" v-if="crop">
        <input
          @change="uploadCover"
          ref="input"
          type="file"
          class="abs_clip"
          accept="image/png, image/jpeg, image/gif, image/jpg"
        />
      </label>
    </div>
    <app-dialog2 @confirm="uploadCropImg" :visible.sync="cropDialog" title="裁剪图片" size="small">
      <div class="crop-area auto" :style="{ height: cropAreaHeight, width: cropAreaWidth }">
        <vue-cropper
          v-if="cropDialog"
          ref="cropper"
          class="cropper"
          :img="cropImg"
          output-type="jpeg"
          :output-size="1"
          :canMove="false"
          :canScale="false"
          :auto-crop-width="cropBoxWidth"
          :auto-crop-height="cropBoxHeight"
          :auto-crop="true"
          centerBox
          full
          :fixed="true"
          :fixedNumber="[1, 1]"
        ></vue-cropper>
      </div>
    </app-dialog2>
  </el-upload>
</template>

<script>
import { UPLOAD_URL } from '@/utils/const'
import { VueCropper } from 'vue-cropper'

export default {
  name: 'AppUpload',
  components: {
    VueCropper,
  },
  props: {
    size: {
      type: String,
      default: 'normal',
    },
    file: String,
    beforeText: String,
    afterText: String,
    name: {
      type: String,
      default: 'image',
    },
    accept: {
      type: String,
      default: 'image/*',
    },
    onSuccess: {
      type: Function,
      default: () => {},
    },
    disabled: Boolean,
    canDelete: Boolean,
    crop: Boolean,
    height: Number,
  },
  data() {
    return {
      action: UPLOAD_URL,
      cropDialog: false,
      // 本地上传裁剪的图片
      cropImg: '',
      // 裁剪区域的大小
      cropAreaHeight: 0,
      cropAreaWidth: 0,
      // 裁剪框的大小
      cropBoxWidth: 0,
      cropBoxHeight: 0,
      imgScale: 1,
      // 上传图片类型
      uploadImgType: '',
      imgBolb: null,
    }
  },
  methods: {
    onError(err) {
      this.$message.error('上传图片失败')
    },
    handleImgClick() {
      if (this.canDelete) {
        window.open(this.file, '_blank')
      }
    },
    uploadCover(event) {
      const file = event.target.files[0]
      const filename = event.target.value
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|JPEG|PNG|BMP)$/.test(filename)) {
        this.$message.warning('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
        return
      }
      const reader = new FileReader()
      reader.onload = e => {
        let data
        // 把Array Buffer转化为blob 如果是base64不需要
        if (typeof e.target.result === 'object') {
          this.tempObjectURL && window.URL.revokeObjectURL(this.tempObjectURL)
          this.imgBolb = new Blob([e.target.result], {
            type: `image/${filename.split('.').pop()}`,
          })
          this.tempObjectURL = data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }
        this.cropImg = data
        this.getImgHeight(data, (width, height, scale) => {
          this.cropAreaHeight = height + 'px'
          this.cropAreaWidth = width + 'px'
          this.cropBoxHeight = this.cropBoxWidth = Math.floor(Math.min(width, height))
          this.imgScale = scale
          this.cropDialog = true
          this.$nextTick(() => {
            this.$refs.cropper && (this.$refs.cropper.scale = this.imgScale)
          })
        })
      }
      // 转化为blob
      reader.readAsArrayBuffer(file)
    },
    // 根据图片地址计算图片的高度
    getImgHeight(src, cb, cropAreaWidth = 536) {
      const img = new Image()
      img.onload = () => {
        const scale = cropAreaWidth / img.width
        cb(cropAreaWidth, img.height * (cropAreaWidth / img.width), scale)
      }
      img.src = src
    },
    // 上传裁剪后的图片
    uploadCropImg() {
      const cropper = this.$refs.cropper
      if (!cropper) return
      const cb = res => {
        this.onSuccess(res)
        this.cropDialog = false
      }
      // 上传裁剪后的图
      cropper.getCropBlob(data => {
        this.uploadByFormData(data, cb)
      })
    },
    // 用formData上传
    uploadByFormData(data, cb) {
      const xhr = new XMLHttpRequest()
      const fd = new FormData()
      fd.append(this.name, data, `${Date.now()}.jpg`)
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200 || xhr.status === 201) {
            try {
              const res = JSON.parse(xhr.responseText)
              if (res.c === 200) {
                cb && cb(res)
              } else {
                this.$message.error(res.m)
              }
            } catch (error) {
              console.log(error)
              this.$message.error('上传图片失败')
            }
          } else {
            this.$message.error('上传图片失败')
          }
        }
      }
      xhr.open('POST', this.action, true)
      xhr.send(fd)
    },
    // 裁剪对话框关闭
    cropDialogClose() {
      this.$refs.input && (this.$refs.input.value = null)
      this.imgBolb = null
      this.cropImg = ''
      this.tempObjectURL && window.URL.revokeObjectURL(this.tempObjectURL)
    },
  },
  watch: {
    cropDialog(val) {
      if (!val) {
        this.cropDialogClose()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.app-upload {
  width: 160px;
  height: 160px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
  background-color: #fff;
  &.big {
    width: 200px;
    height: 200px;
  }
  .img {
    width: 100%;
    height: 100%;
    background: center/contain no-repeat;
  }
  .upload-icon {
    position: absolute;
    width: 44px;
    height: 40px;
    background-image: url(~@/assets/img/icon/upload.png);
    top: 46px;
    left: 50%;
    transform: translateX(-50%);
  }
  .bottom {
    position: absolute;
    width: 100%;
    height: 32px;
    left: 0;
    bottom: 0;
    background: rgba(255, 140, 169, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 22px;
    color: #ffffff;
  }
}
.close-wrapper {
  position: absolute;
  right: 0;
  top: 0;
  width: 32px;
  height: 32px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0 0 0 32px;
  cursor: pointer;
}
.close-icon {
  position: absolute;
  width: 9px;
  height: 9px;
  right: 8px;
  top: 8px;
  background-image: url(~@/assets/img/icon/close2.png);
}
.label {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
}
.crop-area {
  position: relative;
  max-height: 75vh;
  .cropper {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-repeat: repeat;
  }
}
</style>
